export default __webpack_public_path__ + "static/media/minivista-22oct.8ee635e3.jpg";